import { createSelector } from 'reselect';

const indicationsStateSelector = state => state.indicationsReducer;

export const indicationsListSelector = createSelector(
    indicationsStateSelector,
    indicationsState => indicationsState.indications
);
